<template>
    <div class="form-item">
        <label class="label-caption">Tipo de Evento</label>
        <select :value="opcaoSelecionada" @change="atualizarOpcao" class="form-control" v-bind="$attrs">
            <option v-for="tipo in lsTipos" :key="tipo.id" :value="tipo.id">{{ tipo.descricao }}</option>
        </select>
    </div>
</template>

  
<script setup>
import { computed } from 'vue'


const props = defineProps({
    ckAddTodos: {type: Boolean, default: false},
    opcaoSelecionada: {type: String, default: ''}
})


const emit = defineEmits(['update:opcaoSelecionada'])


const lsTipos = computed(() => {
    const tipos = [
        { id: '0', descricao: 'Evento simples' },
        { id: '1', descricao: 'Abertuda de OS' },
        { id: '2', descricao: 'Evento simples OS' },
        { id: '3', descricao: 'Encerramento de OS' },
        { id: '4', descricao: 'Pausa OS' },
        { id: '5', descricao: 'Retomada de OS' },
        { id: '6', descricao: 'Adiamento de OS' },
        { id: '8', descricao: 'Saída Garagem' },
        { id: '9', descricao: 'Retorno Garagem' },
    ];
    if (props.ckAddTodos) {
        tipos.unshift({ id: '', descricao: 'TODOS' })
    }
    return tipos
})


function atualizarOpcao(event) {
    emit('update:opcaoSelecionada', event.target.value)
}
</script>